// src/StandaloneForm.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api, api_noIntercept } from './axios';
import { CustomerPortalContent } from './CustomerPortal';
import { CP_UserPermissionsProvider } from './CPUserPermissionsContext';
import { useAuth } from './AuthContext';

export default function StandaloneForm() {
  const { search }  = useLocation();
  const navigate    = useNavigate();
  const params      = new URLSearchParams(search);
  const moduleId    = Number(params.get('moduleId'));
  const recordId    = Number(params.get('recordId'));
  const token       = params.get('token');

  const [loggedIn,       setLoggedIn]       = useState(false);
  const [moduleContent,  setModuleContent]  = useState(null);
  const [viewMode,       setViewMode]       = useState('form');
  const [navigationPath, setNavigationPath] = useState([{ moduleId, recordId }]);

  const { updateUser } = useAuth();

  // 1) Auto-login & cookie zetten
  useEffect(() => {
    if (!token) return navigate('/login', { replace: true });
    api_noIntercept.post('/auto-login', { token })
        .then(res => {
            // 1) update AuthContext met je user‐object
            updateUser({ ...res.data.user, autoLogin: true });
            // 2) nu AuthContext.user in CustomerPortalContent geldig
            setLoggedIn(true);
            })
        .catch(() => navigate('/login', { replace: true }));
  }, [token, navigate]);

  // 2) Module‐config ophalen (zelfde API als in normale flow)
  useEffect(() => {
    if (!loggedIn) return;
    api.post('/api/get_company_portal_module', { moduleId })
      .then(({ data }) => {
        const def = JSON.parse(data.module_json_definition);
        setModuleContent(def);
      })
      .catch(() => {/* fallback of error‐overlay */});
  }, [loggedIn, moduleId]);

  if (!loggedIn || !moduleContent) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <CP_UserPermissionsProvider>
        <CustomerPortalContent
            moduleContent={moduleContent}
            selectedCP_MenuItem={moduleContent.module_description}
            setModuleContent={setModuleContent}
            
            // Standalone nav-props          
            standalone={true}
            initialViewMode="form"
            initialNavigationPath={[{ moduleId, recordId }]}
        />
    </CP_UserPermissionsProvider>
  );
}
